const errors = {
  AdvancePricingItineraryCombinationException: {
    message: 'messages.no_flights_error',
    icon: 'fa-plane-slash',
    title: 'we_are_sorry',
  },
  AdvanceFareException: {
    message: 'messages.no_flights_error',
    icon: 'fa-plane-slash',
    title: 'we_are_sorry',
  }
}

const defaultError = {
  message: 'session_error',
  title: 'we_are_sorry',
  icon: 'fa-x',
}

export default function handleError(errorType) {
  return errors[errorType] || defaultError
}
